import getType from './getType';

/**
 * Merge one or more objects together
 *
 * @return {Object}
 */
export default function merge () {
  const merged = {};

  for (let i = 0; i < arguments.length; i++) {
    for (const [key, value] of Object.entries(arguments[i])) {
      if (getType(value) === 'object' && merged[key]) {
        merged[key] = merge(merged[key], value);
      } else {
        merged[key] = value;
      }
    }
  }

  return merged;
}
